module.exports = __webpack_public_path__ + "img/tutorial_mindNote_02.8282b080.png";